import './_styles.scss';
import React from "react";
import Category from './Category';

import Decor from "assets/decor.png";
import Chair from "assets/chair.png";
import KidsToy from "assets/kids_toys.png";
import KiddyPool from "assets/kiddy_pool.png";
import Stroller from "assets/evenflo_stroller_2.jpg";

const default_data = [
  {
    image: Chair,
    badge: '#EF6500',
    title: 'inflatables',
    caption: 'AirBeds & Chairs'
  },
  {
    image: Decor,
    badge: '#866A45',
    title: 'home decor',
    caption: 'Carpets & Lamps'
  },
  {
    image: Stroller,
    badge: '#A12789',
    title: 'baby strollers',
    caption: 'Strollers & Carries'
  },
  {
    image: KidsToy,
    badge: '#F0C90B',
    title: 'kids toys',
    caption: 'Chargeable Kids Cars'
  },
  {
    image: KiddyPool,
    badge: '#CF1308',
    title: 'floaties',
    caption: 'Kiddy Pools & Floaties'
  },
  {
    image: KidsToy,
    badge: '#F0C90B',
    title: 'kids toys',
    caption: 'Chargeable Kids Cars'
  },
  {
    image: KidsToy,
    badge: '#F0C90B',
    title: 'kids toys',
    caption: 'Chargeable Kids Cars'
  },
  {
    image: KidsToy,
    badge: '#F0C90B',
    title: 'kids toys',
    caption: 'Chargeable Kids Cars'
  }
]

export default ({ start=0, end=0, data=default_data, minimal=false }) => (
  <section className={`Section-Categories ${!minimal ? '' : 'Minimal'}`}>
    <div className="Section-Wrapper">

      <div className="Title">
        { !minimal && 'Shop by Department' }
      </div>

      { data.slice(start,end).map((x,i) => <Category key={i} {...x}/>) }

    </div>
  </section>
);
